var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shell-box"},[_c('el-breadcrumb',{staticClass:"breadcrumb",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/myHome' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',{attrs:{"to":{
        path: `/routerPolicyManagement/${this.$route.meta.policyRoute}/policyManagement`,
      }}},[_vm._v("员工列表")]),_c('el-breadcrumb-item',[_vm._v("员工详情")])],1),_c('div',{staticClass:"form"},[_c('detailsa',{attrs:{"userInfo":_vm.policyDetail}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }